export const dataURLtoBlob = (dataURL, dataMIMEType) => {
  // http://mitgux.com/send-canvas-to-server-as-file-using-ajax
  // Decode the dataURL
  const binary = atob(dataURL.split(',')[1]);
  // Create 8-bit unsigned array
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  // Return our Blob object
  return new Blob([new Uint8Array(array)], { type: dataMIMEType });
};

const imageLoader = (imageEle, data) => {
  return new Promise((resolve, reject) => {
    imageEle.src = data;
    imageEle.onload = function() {
      resolve({ height: imageEle.naturalHeight, width: imageEle.width });
    };
  });
};

const BASE_QUALITY_FACTOR = 0.1;

/**
 * Receives an Image Source (can be Base64 ) and returns a resized Image data
 * @param {String} imageData The source Image Object
 * @param {Integer} resizeTo The output quality of Image Object
 * @param {String} outputFormat. Possible values are jpg, png, and webp
 * @return {String} resizedImageData The resized Image data
 */
export const resize = async (imageData, resizeTo = 1000000, outputFormat = 'jpeg') => {
  let mimeType;
  switch (outputFormat.toLowerCase()) {
    case 'png':
      mimeType = 'image/png';
      break;
    case 'webp':
      mimeType = 'image/webp';
      break;

    default:
      mimeType = 'image/jpeg';
      break;
  }

  const blob = dataURLtoBlob(imageData, mimeType);

  if (blob && blob.size) {
    if (blob.size < resizeTo) {
      return imageData;
    }
  }
  const sourceImageEle = new Image();
  const { height, width } = await imageLoader(sourceImageEle, imageData);

  const qualityFactor = Math.floor((resizeTo * 100) / blob.size);
  // minimising quality with a factor of 5% again for safety
  const RoundedQualityFactor = qualityFactor > 15 ? qualityFactor - 5 : BASE_QUALITY_FACTOR;
  const cvs = document.createElement('canvas');
  cvs.width = width;
  cvs.height = height;
  const ctx = cvs.getContext('2d');
  ctx.drawImage(sourceImageEle, 0, 0);
  const resizedImageData = cvs.toDataURL(mimeType, RoundedQualityFactor / 100);
  return resizedImageData;
};

export const replaceWithJioCDN = (url = '') => {
  try {
    let clientJioCDNEnabled = false;
    let assetConfig = {};
    let clientJioCDNUrl = '';
    let assetUrls = [];
    if (window && window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.flags) {
      assetConfig = window.__PRELOADED_STATE__.flags.assetConfig;
      clientJioCDNEnabled = assetConfig && assetConfig.isJioCDNEnabled === 'ON';
      clientJioCDNUrl = (assetConfig && assetConfig.jioCDNAssetUrl) || '';
      assetUrls = (assetConfig && assetConfig?.assetUrls) || [];
    }
    if (!clientJioCDNEnabled) return url;
    const matchedDomain = assetUrls?.find(domain => url?.startsWith(domain));
    return matchedDomain ? clientJioCDNUrl + url?.slice(matchedDomain.length) : url;
  } catch (error) {
    return url;
  }
};

export const compress = () => {};
